import { organizationApi } from "@/core/data/api";

export default async (condition) => {
  return await organizationApi.getOrganizationListPagination(condition);
};
